import { render } from "./UsersGroups.vue?vue&type=template&id=146511ce"
import script from "./UsersGroups.vue?vue&type=script&lang=js"
export * from "./UsersGroups.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work2022\\300_NEVTER\\500_DEVEL\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__